import { styled } from '@withjoy/joykit';
export const SearchButtonRoot = styled.button`
  align-items: center;
  background-color: transparent;
  border: none;
  border-radius: 24px;
  cursor: pointer;
  display: none;
  height: 48px;
  justify-content: center;
  padding: 0;
  width: 48px;

  ${({ theme }) => theme.mediaQueries.md} {
    display: flex;
  }

  &:focus-visible {
    outline: 0.125rem solid ${({ theme }) => theme.colors.newUIBrandPrimary};
  }

  svg {
    color: ${({ theme }) => theme.colors.mono14};
    display: block;
    transition: color 0.15s ease;
  }

  &:hover svg {
    color: ${({ theme }) => theme.colors.newUIBrandPrimary};
  }
`;
